module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }, [_c('h1', {
    staticClass: "title-acknowPage"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("I have been honoured and privileged to work with two giants of local history. I now know that Christmas comes more than once a year – indeed, every time I meet up with them, another ‘Pandora’s Box’ is opened. Between them they have over a hundred years experience in the field of local history research and make my twenty-five seem paltry. They have both been unstintingly generous, kind and friendly, whether it was in Stanley’s shed or Leslie’s attic, and I can only hope that the trust they have placed in me will be in some way acknowledged by the publication of these books. My grateful thanks to you both.")]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Stanley Sheead and Leslie Robinson.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781783408566_i0003.jpg",
      "src": "images/e9781783408566_i0003.jpg"
    }
  })])])])]), _c('a', {
    attrs: {
      "id": "title2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61e8fc60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781783408566_ack01.vue
// module id = 75
// module chunks = 0